import { render } from "./import-products.vue?vue&type=template&id=d7e5de46"
import script from "./import-products.vue?vue&type=script&setup=true&lang=js"
export * from "./import-products.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/noon/import-products.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d7e5de46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d7e5de46', __exports__)) {
    console.log('reload')
    api.reload('d7e5de46', __exports__)
  }
  
  module.hot.accept("./import-products.vue?vue&type=template&id=d7e5de46", () => {
    console.log('re-render')
    api.rerender('d7e5de46', render)
  })

}


export default __exports__